import { Injectable } from '@angular/core';
import { BookmarkRecord } from 'fl-bookmarks';
import { ResourceVm } from 'qp-ui-interface';
import { Observable, Subject } from 'rxjs';
import { PlayerState } from 'src/app/shared/enums/player-states';
import { PlaybackService } from 'src/app/shared/services/playback.service';
import { getDetailsButton } from 'src/app/shared/utils/EntitlementUtils';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';

@Injectable()
export class DetailPageModeService {
  private playerState$ = new Subject<PlayerState>();
  constructor(
    private localStorage: LocalStorageService,
    private readonly playbackService: PlaybackService
  ) {}

  get playerStateValue$(): Observable<PlayerState> {
    return this.playerState$.asObservable();
  }

  setPlayerState(state: PlayerState) {
    this.playerState$.next(state);
  }

  /**
   * Gets the button text to display on the details page
   */
  getButtonText(
    contentEntitlement: string,
    isLoggedIn: boolean,
    freePreviewAvailable: boolean,
    isSubscribed: boolean,
    contentType: string,
    resource: ResourceVm,
    freeFirstEpisode?: boolean
  ): string {
    return getDetailsButton(
      contentEntitlement,
      isLoggedIn,
      freePreviewAvailable,
      isSubscribed,
      contentType,
      resource,
      this.localStorage,
      freeFirstEpisode
    );
  }

  getResourceAction(
    activeResource: ResourceVm,
    resource: ResourceVm,
    bookmark?: BookmarkRecord
  ) {
    return this.playbackService.getResourceActionState(
      activeResource,
      resource,
      bookmark
    );
  }
}
